import fotos_borito from './fotos_borito.json';
import init from './../../cover_template.json';

export default {
  fotos_borito,
  init,
};



// WEBPACK FOOTER //
// ./src/config/templates/covers/consumer/landscape/index.jsx